// @ts-check

import React, { useState } from 'react';
import store from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '../../custom/Accordion';
import AccordionSummary from '../../custom/AccordionSummary';
import AccordionDetails from '../../custom/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import useFormStyles from '../../common/FormStyle';
import { LOCATIONS } from '../common/locations-dropdown';
import locations from '../../../testdata/locations.json';
import {
  SET_LOCATION,
  SET_COUNTRY,
  SET_PLOT_LENGTH,
  SET_PLOT_WIDTH,
  SET_UNITS,
  INPUT_CHANGED
} from '../../../redux/actions/actionTypes'

const useStyles = makeStyles((theme) => ({
  locationControl: {
    margin: theme.spacing(1),
    minWidth: 90,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

/* 
    The plot info section of the form
    This component will already be inside a <form></form> tag
*/
function PlotInfo(props) {
  const formStyles = useFormStyles();
  const dispatch = useDispatch()
  const rootState = useSelector(state => state);
  const buildingInfoState = useSelector(state => state.globalFormData.buildingInfo);
  const units = useSelector(state => state.globalFormData.buildingInfo.units);
  const validationState = useSelector(state => state.globalFormData.validation);

  const styles = useStyles()

  const [expanded, setExpanded] = useState(false);
  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  var countries = []
  LOCATIONS.map((val) => {
    const mkey = val.val.split(',')[0]
    if (!countries.includes(mkey)) {
      countries.push(mkey)
    }
  });
  // console.log(countries);
  const [selectedCountry, setSelectedCountry] = useState(buildingInfoState.country || 'United Kingdom')

  const [selectedLocation, setSelectedLocation] = useState(LOCATIONS.filter(r => r.val.includes(selectedCountry)))
  return (
    <Accordion expanded={expanded} onChange={handleExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        aria-controls="plotInfo-content"
        id="plotInfo-header"
        IconButtonProps={{
          className: formStyles.expandButton
        }}
      >
        <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)}>Plot</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box className={formStyles.w100}>
          {/* Plot location */}




          <FormControl className={styles.locationControl}>
            <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)}>
              Country
            </Typography>
            {/* <InputLabel>Location</InputLabel> */}
            <Select
              // labelId="demo-simple-select-label"s
              // id="demo-simple-select"
              value={buildingInfoState.country}
              onChange={(e) => {
                setSelectedCountry(e.target.value)
                let x = LOCATIONS.filter(r => r.val.includes(e.target.value))
                let key = x[0].key
                setSelectedLocation(x)
                dispatch({
                  type: SET_COUNTRY,
                  payload: e.target.value
                })
                // dispatch({
                //   type: SET_LOCATION,
                //   payload: key
                // })
                // console.log(locations[key], '[[[[[[[[[[')
              }}
            >

              {countries.map((loc, i) => {
                return <MenuItem value={loc} key={i}>{loc}</MenuItem>
              })}

            </Select>
          </FormControl>

          <FormControl className={styles.locationControl}>
            <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)}>
              Location
            </Typography>
            {/* <InputLabel>Location</InputLabel> */}
            <Select
              // labelId="demo-simple-select-label"
              // id="demo-simple-select"
              value={buildingInfoState.location}
              onChange={(event) => {
                dispatch({
                  type: SET_LOCATION,
                  payload: event.target.value
                })
              }}
            >

              {selectedLocation.map((loc, i) => {
                return <MenuItem value={loc.key} key={i}>{loc.val.split(',')[1] || loc.val}</MenuItem>
              })}

            </Select>
          </FormControl>

          <Divider className={formStyles.divider} />

          {/* Plot dimensions */}
          <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)}>
            Plot dimensions
          </Typography>
          <Typography variant="body2" className={formStyles.greyText}>
            Plooto beta works for rectangular plots only
          </Typography>

          {/* <Typography variant="body2" className={formStyles.greyText}>
            All dimensions are in meters (for now)
          </Typography> */}
          <FormControl className={styles.locationControl}>
            <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)}>
              Select Unit
            </Typography>
            <Select
              value={buildingInfoState.units}
              onChange={(e) => {
                console.log(e.target.value)
                dispatch({
                  type: SET_UNITS,
                  payload: e.target.value
                })

                setTimeout(() => {
                  const newState = store.getState()
                  console.log('time')
                  dispatch({
                    type: INPUT_CHANGED,
                    payload: {
                      rootState: newState
                    }
                  })
                }, 2);
              }}
            >

              {['m', 'ft'].map((loc, i) => {
                return <MenuItem value={loc} key={i}>{loc}</MenuItem>
              })}

            </Select>
          </FormControl>


          {/* Length x depth */}
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding={2}
          >
            <TextField
              error={!validationState.plot_dimension_x.valid}
              helperText={!validationState.plot_dimension_x.valid && (units === 'm' ? validationState.plot_dimension_x.errText : validationState.plot_dimension_x.errTextFt)}
              variant="outlined"
              placeholder="Length"
              name="plot_length"
              size="small"
              type="number"
              style={{
                width: "40%"
              }}
              value={buildingInfoState.plot_length}
              onChange={(event) => {
                dispatch({
                  type: SET_PLOT_LENGTH,
                  payload: event.target.value
                })
              }}
              onBlur={(event) => {
                dispatch({
                  type: INPUT_CHANGED,
                  payload: {
                    rootState
                  }
                })
              }}

              inputProps={{
                className: formStyles.inputField
              }}
            />
            <CloseIcon className={formStyles.margin2} />
            {/* Plot width */}
            <TextField
              error={!validationState.plot_dimension_y.valid}
              helperText={!validationState.plot_dimension_y.valid &&
                (units === 'm' ? validationState.plot_dimension_y.errText : validationState.plot_dimension_y.errTextFt)}
              variant="outlined"
              placeholder="Depth"
              name="plot_width"
              size="small"
              type="number"
              style={{
                width: "40%"
              }}
              value={buildingInfoState.plot_width}
              onChange={(event) => {
                dispatch({
                  type: SET_PLOT_WIDTH,
                  payload: event.target.value
                })
              }}
              onBlur={(event) => {
                dispatch({
                  type: INPUT_CHANGED,
                  payload: {
                    rootState
                  }
                })
              }}
              inputProps={{
                className: formStyles.inputField
              }}
            />
          </Box>

        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default PlotInfo